import script from "./ChatTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatTab.vue?vue&type=script&setup=true&lang=js"

import "./ChatTab.vue?vue&type=style&index=0&id=d8c5d230&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8c5d230"]])

export default __exports__